import format from "date-fns/format";
import React, {Component} from "react";
import DatePicker from "react-datepicker";
import {connect} from "react-redux";
import {AccountHeads, NewInventoryProduct,} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import AutoComplete from "../../../Components/AutoComplete";
import ReportTable from "./ReportTable";
import Statistics from "./Statistics";

const date = new Date();
class PurchaseReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        date.getDay()
      ),
      endDate: new Date(),
      PurchaseData: false,
      fetchData: false,
      account: "",
      route: "",
      product: "",
      btnDisable: false,
    };
  }

  onChange = (dates) => {
    const [start, end] = dates;
    this.setState({ startDate: start, endDate: end });
  };

  fetchPurchaseData() {
    ApiConnect.get(`/Module/SalesPurchase/Purchase/PurchaseData`)
      .then((response) => {
        this.setState({ PurchaseData: response.data });
        this.props.AccountHeads(response.data.account);
        this.props.NewInventoryProduct(response.data.products);
      })
      .catch((error) => console.log(error));
  }
  autoCompleteAction = (e) => {
    this.setState({ account: e.id });
  };
  productAutocomplete = (e) => {
    this.setState({ product: e.id });
  };
  handleReset() {
    this.setState({
      account: "",
      route: "",
      product: "",
      startDate: new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        date.getDay()
      ),
      endDate: new Date(),
    });
  }
  componentDidMount = () => {
    this.fetchPurchaseData();
  };
  fetchData = () => {
    this.setState({ btnDisable: true });
    try {
      ApiConnect.get(
        `/Module/SalesPurchase/Purchase/Report?from=${
          this.state.startDate ? format(this.state.startDate, "yyyy-MM-dd") : ""
        }&to=${
          this.state.endDate ? format(this.state.endDate, "yyyy-MM-dd") : ""
        }&account=${this.state.account}&route=${this.state.route}&product=${
          this.state.product
        }&limit`
      )
        .then((response) => {
          this.setState({ fetchData: response.data, btnDisable: false });
        })
        .catch((err) => console.error(err));
    } catch (err) {
      this.setState({ btnDisable: false });
      console.log("error facing location:", err);
    }
  };
  render() {
    const Accounts = this.props.accountHead;
    const productList = this.props.productList;
    return (
      <>
        {" "}
        <div className="card">
          <div className="card-title">
            <h2 className="col-4">Purchase Report</h2>
            <div className="row">
              <div className="col-3 form-group">
                <label>Account Head</label>
                {Accounts.length !== 0 ? (
                  <AutoComplete
                    name="accounthead"
                    action={this.autoCompleteAction}
                    placeHolder="Account Head"
                    styleName=""
                    items={Accounts}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-3 form-group">
                <label>Product</label>
                {productList.length !== 0 ? (
                  <AutoComplete
                    name="productname"
                    action={this.productAutocomplete}
                    placeHolder="Product Search"
                    styleName=""
                    items={productList}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-3 form-group">
                <label>Date Range</label>
                <DatePicker
                  selected={this.state.startDate}
                  onChange={this.onChange}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  maxDate={new Date()}
                  excludeDates={[(new Date(), 1), (new Date(), 5)]}
                  selectsRange
                  selectsDisabledDaysInRange
                  className="form-control"
                />
              </div>
              <div className="col-3 form-group">
                <button
                  className="btn btn-secondary col"
                  onClick={() => {
                    this.handleReset();
                  }}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary col"
                  onClick={() => this.fetchData()}
                >
                  Fetch
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.fetchData ? (
          <>
            <Statistics data={this.state.fetchData} type="purchase" />
            <ReportTable
              data={this.state.fetchData.ProductData}
              type="purchase"
            />
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({
    accountHead: state.Accounts.AccountHead,
    productList: state.Inventory.Products,
  }),
  { AccountHeads, NewInventoryProduct }
)(PurchaseReport);
